export default {
  API_ERROR: "Tyvärr, något gick fel. Vänligen försök igen.",
  FORM_ERROR: "Tyvärr, men du måste skriva lite mer för att dela din feedback med oss."
}